import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, FormControl, Button } from 'react-bootstrap';
import lens from '../assets/images/lens.png';


const SearchBar = () => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };


  const handleSearch = (e) => {
    e.preventDefault();
    
    if (query.trim() !== '') {
      // Redirection vers la page de recherche avec le paramètre de requête
      navigate(`/search?query=${encodeURIComponent(query)}`);
      setQuery('');
    }
  };

  return (
      <Form className="d-flex m-0 w-100" onSubmit={handleSearch} >
        <FormControl
          type="search"
          placeholder=""
          style={{borderRadius: "0"}}
          value={query}
          onChange={handleInputChange}
        />
        <Button
          style={{backgroundColor: "#5000ff", borderRadius : "0", borderColor : "light-grey"}}
          variant="link"
          type="submit"
        >
          <img src={lens} style={{width : "1.5rem"}}/>
        </Button>
      </Form>
  );
};

export default SearchBar;
